import React from 'react'
import ConversationListItemView from 'components/ConversationList/ListItem'
import useShadowEventFromRoom from 'subapps/chat/hooks/useShadowEventFromRoom'

const ListItemView = ({
  lastMessageEventId,
  lastMessageIsNote,
  matrixRoomId,
  snippetText: possibleSnippetText,
  ...rest
}) => {
  const mxEvent = useShadowEventFromRoom(
    matrixRoomId,
    lastMessageIsNote && lastMessageEventId
  )

  // NOTE (jscheel): This cannot be memoized properly because matrix mutates
  // objects with wreckless abandon.
  let snippetText = possibleSnippetText
  if (lastMessageIsNote && mxEvent) {
    snippetText = mxEvent.getContent()?.body
  }

  return <ConversationListItemView {...rest} snippetText={snippetText} />
}

export default ListItemView
